"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountFilterRequestSchema = void 0;
const yup_1 = require("yup");
const AccountFilterRequestSchema = (0, yup_1.object)().shape({
    text: (0, yup_1.string)(),
    name: (0, yup_1.string)(),
    ddi: (0, yup_1.string)(),
    ip: (0, yup_1.string)(),
    page: (0, yup_1.number)().required().min(0),
    max: (0, yup_1.number)().required().max(100),
    sort: (0, yup_1.string)(),
    sortField: (0, yup_1.string)(),
});
exports.AccountFilterRequestSchema = AccountFilterRequestSchema;
